import { render } from "./enrolments-actions.vue?vue&type=template&id=383354c0&ts=true"
import script from "./enrolments-actions.ts?vue&type=script&lang=ts&external"
export * from "./enrolments-actions.ts?vue&type=script&lang=ts&external"

import "./enrolments-actions.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__